import { trueFalseToYesNo } from '@/util/formatters'
let claimDetailsInputs = [
    {
        id: 'claimReference',
        label: 'Claim Reference',
        type: 'text',
        placeholder: 'Claim Reference',
        dataPath: 'claimReference'
    },
    {
        id: 'relatedReference',
        label: 'Related Reference',
        type: 'text',
        placeholder: 'Related Reference',
        dataPath: 'relatedReference'
    },
    {
        id: 'incidentType',
        label: 'Claim Type',
        type: 'text',
        placeholder: 'Claim Type',
        dataPath: 'claimType'
    },
    {
        id: 'submitted',
        label: 'Submitted Date',
        type: 'text',
        placeholder: 'Submitted Date',
        dataPath: 'dateCreated'
    },
    {
        id: 'submittedAfterDays',
        label: 'Submitted after incident (days)',
        type: 'text',
        placeholder: 'Submitted after incident (days)',
        dataPath: 'submittedAfterIncident'
    },
    {
        id: 'claimStatus',
        label: 'Claim Status',
        type: 'text',
        placeholder: 'Claim Status',
        dataPath: 'claimStatus'
    },
    {
        id: 'incidentDate',
        label: 'Incident Date',
        type: 'text',
        placeholder: 'Incident Date',
        dataPath: 'incidentDate'
    },
    {
        id: 'incidentTime',
        label: 'Incident Time',
        type: 'text',
        placeholder: 'Incident Time',
        dataPath: 'incidentDetails.incidentTime'
    },
    {
        id: 'description',
        label: 'Incident Description',
        type: 'textarea',
        placeholder: 'Incident Description',
        dataPath: 'incidentDetails.description'
    },
    {
        id: 'location',
        label: 'Incident Location',
        type: 'textarea',
        placeholder: 'Incident Location',
        dataPath: 'incidentDetails.location'
    },
    {
        id: 'otherClaims',
        label: 'Other Claims (last 2 years)',
        type: 'text',
        placeholder: 'Other Claims',
        dataPath: 'otherClaims',
        customFormatter: trueFalseToYesNo
    },
    {
        id: 'otherClaimsGadgetDetails',
        label: 'Other Claims Gadget Details',
        type: 'text',
        placeholder: 'Other Claims Gadget Details',
        dataPath: 'otherClaimsGadgetDetails'
    },
    {
        id: 'otherClaimsCompanyName',
        label: 'Other Claims Company Name',
        type: 'text',
        placeholder: 'Other Claims Company Name',
        dataPath: 'otherClaimsCompanyName'
    },
    {
        id: 'otherClaimsOutcome',
        label: 'Other Claims Outcome',
        type: 'text',
        placeholder: 'Other Claims Outcome',
        dataPath: 'otherClaimsOutcome'
    }
]

export { claimDetailsInputs }